// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3iIBK","left":"InfoRow_left__3GH28"};